<template>
  <div class="exam-calc">
    <md-layout
      :md-gutter="24"
      md-flex="100"
    >
      <md-layout
        md-flex="100"
        class="inputs-calc"
      >
        <md-input-container
          class="warning-message"
          :class="{
            'md-input-invalid': exam.fields.weight && (exam.fields.weight > 150 || exam.fields.weight < 3)
          }"
        >
          <label>Peso (kg)</label>
          <md-input
            id="weight"
            v-model="exam.fields.weight"
            v-validate="'required'"
            v-mask="weight"
            data-vv-validate-on="none"
            name="weight"
            minlength="3"
            maxlength="6"
            title="Peso (kg)"
            placeholder="Peso (kg)"
            @keyup.enter.native="calculate()"
          />
          <input
            v-model="exam.fields.weight"
            v-mask="weight"
            type="hidden"
          >
          <span
            v-if="exam.fields.weight && (exam.fields.weight > 150 || exam.fields.weight < 3)"
            class="md-error"
          >
            Atenção para a digitação, valor atípico
          </span>
        </md-input-container>
        <md-input-container
          class="warning-message"
          :class="{ 'md-input-invalid': exam.fields.height && (exam.fields.height > 200 || exam.fields.height < 50) }"
        >
          <label>Altura (cm)</label>
          <md-input
            id="height"
            v-model="exam.fields.height"
            v-validate="'required'"
            v-mask="`###`"
            name="height"
            maxlength="3"
            title="Altura (cm)"
            placeholder="Altura (cm)"
            @keyup.enter.native="calculate()"
          />
          <input
            v-model="exam.fields.height"
            v-mask="`###`"
            type="hidden"
          >
          <span
            v-if="exam.fields.height && (exam.fields.height > 200 || exam.fields.height < 50)"
            class="md-error"
          >
            Atenção para a digitação, valor atípico
          </span>
        </md-input-container>
        <button
          class="btn btn-primary btn-calc"
          @click="calculate()"
        >
          Calcular
        </button>
      </md-layout>
    </md-layout>
    <div class="calc-card__result">
      <template>
        <p>
          Resultado: <span>{{ exam.result }}m²</span>
        </p>
      </template>
    </div>
  </div>
</template>
<script>
import createNumberMask from 'text-mask-addons/dist/createNumberMask'

export default {
  name: 'CalcSuperfícieCorporal',

  data() {
    return {
      exam: {
        fields: {
          weight: null,
          height: null
        },
        result: 0
      },
      weight: createNumberMask({
        prefix: '',
        includeThousandsSeparator: false,
        allowNegative: false,
        allowDecimal: true,
        decimalSymbol: '.',
        decimalLimit: 2,
        requireDecimal: false,
        allowLeadingZeroes: true,
        integerLimit: 3
      })
    }
  },
  methods: {
    calculate() {
      if (this.exam.fields.weight && this.exam.fields.height) {
        const weight = +this.exam.fields.weight
        const height = +this.exam.fields.height

        this.exam.result = (0.007184 * Math.pow(height, 0.725) * Math.pow(weight, 0.425)).toFixed(3)
      }
    }
  }
}
</script>

